import React from 'react';
import { Bar, Line } from 'react-chartjs-2';
import { colorGraph, formatLargeNumber } from '../../core/utils/funcoes';
import { FiltroSopProduction } from '../../core/repositories/sopProductionRepositorio';
import SopLoadingAnimation from '../../components/sopLoadingAnimation';
import { ChartData } from 'chart.js';
import { useTranslation } from 'react-i18next';
import { useToast } from '../../core/contexts/toast';
import { RepositorioSopProduction } from '../../core/repositories/sopProductionRepositorio';



const SopProductionRevenueStackedBarChart: React.FC<{ filtro: FiltroSopProduction }> = (props) => {
  const { mostrarToast } = useToast();
  const { t } = useTranslation();
  const [data, setData] = React.useState<ChartData<"bar">>({} as ChartData<"bar">);
  const [carregando, setCarregando] = React.useState(true);



  //  SUM(num_packaging_real_units) AS packaging_real_units,
  //  SUM(num_flavor_real_units) AS flavor_real_units,
  //  SUM(num_drying_real_units) AS drying_real_units,
  //  SUM(num_blending_real_units) AS blending_real_units,
  React.useEffect(() => {
    setCarregando(true);
    new RepositorioSopProduction().postRevenueRegion(props.filtro).then((res) => {
      const labels: (number | null)[] = [];
      var datasets: any[] = [];

      res.forEach((item: any) => {
        if (labels.indexOf(item.des_industrial_plant) === -1)
          labels.push(item.des_industrial_plant);

      });
      var aux = {
        label: 'Packaging',
        data: res.map((x: any) => x.packaging_real_units),
        backgroundColor: colorGraph()[1],
      }
      datasets.push(aux);
      aux = {
        label: 'Flavor',
        data: res.map((x: any) => x.flavor_real_units),
        backgroundColor: colorGraph()[2],
      }
      datasets.push(aux);
      aux = {
        label: 'Drying',
        data: res.map((x: any) => x.drying_real_units),
        backgroundColor: colorGraph()[3],
      }
      datasets.push(aux);
      aux = {
        label: 'Blending',
        data: res.map((x: any) => x.blending_real_units),
        backgroundColor: colorGraph()[4],
      }
      datasets.push(aux);

      setData({
        labels: labels,
        datasets: datasets
      });
      setCarregando(false);
    }).catch((error) => {
      mostrarToast({
        titulo: t("pages.Erro!"),
        mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
        tipo: "error",
      });
    })
  }, [props.filtro]);


  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom' as const,
      },

    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          color: '#333',
        },
      },
      y: {
        ticks: {
          color: '#333',
          callback: (value: any) => formatLargeNumber(value, props.filtro?.value !== "Quantity" ? "$" : ""),
        },
        stacked: true,

        title: {
          display: true,
          text: props.filtro?.value !== "Quantity" ? 'Revenue (USD)' : 'Quantity',
          color: '#333',
          font: {
            weight: 'bold',
          },
        },
      },
    },
  };

  return (


    <div className="card p-3 shadow-sm border-0" style={{ height: '250px' }}>
      <strong className=" title-card">{props.filtro?.value !== "Quantity" ? 'Revenue' : 'Quantity'} by Plant and Production Class</strong>

      {carregando ?
        <SopLoadingAnimation type="BAR" />
        :
        <div>
          <Bar options={options} data={data} />
        </div>
      }
    </div>
  );
};
export default SopProductionRevenueStackedBarChart;
